import React , {useEffect} from 'react'
import './CharFadeText.css';
const PrimaryLoading = ({text, type}) => {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 600);
    // check screen size
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 600);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    })
    return (
        <button className={`primary-loading-btn ${type==="print" ? "printing-btn" : "" }`} >
            {(type ==="true-faceup" || type ==="diary") ? <span className='d-block' >{(type ==="diary" && isMobile) ? text?.slice(0,3) + "..." : text  + "..." }</span> :
                (type!=="mobile") ? <span className=' d-md-block'>{ text+ "..."}</span> : <span className='d-block d-md-none'>{text?.slice(0,4) +"..."}</span>
            }

           
        </button>
    )
}

export default PrimaryLoading